import axios from 'axios'
import { auth as endpoint } from '@src/data/endpoint.json'

export const state = {
  currentUser: getSavedState('auth.currentUser'),
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
    saveState('auth.currentUser', newValue)
    setDefaultAuthHeaders(state)
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser
  },

  isAdmin: (state, getters) => {
    if (getters.loggedIn) {
      return state.currentUser.role === 'admin'
    }

    return false
  },

  havePermission: (state, getters) => (permission) => {
    if (getters.loggedIn) {
      return state.currentUser.permissions.includes(permission)
    }

    return false
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch, commit }) {
    setGlobalAxiosConfigs(state, commit)
    setDefaultAuthHeaders(state)
    dispatch('validate')
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { email, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios.post(endpoint.login, { email, password }).then((response) => {
      const user = response.data
      commit('SET_CURRENT_USER', user)
      return user
    })
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('SET_CURRENT_USER', null)
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state }) {
    if (!state.currentUser) return Promise.resolve(null)

    return axios
      .post(endpoint.check)
      .then((response) => {
        const user = response.data
        commit('SET_CURRENT_USER', user)
        return user
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          commit('SET_CURRENT_USER', null)
        }
        return null
      })
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.accessToken
    : ''
}

function setGlobalAxiosConfigs(state, commit) {
  axios.defaults.baseURL = '/api'
  axios.defaults.method = 'post'
  axios.interceptors.response.use(
    (response) => {
      const accessToken = response.headers['set-authorization']
      if (accessToken) {
        const { currentUser } = state
        const newData = Object.assign({}, currentUser, { accessToken })
        commit('SET_CURRENT_USER', newData)
      }
      return response
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        commit('SET_CURRENT_USER', null)
      }
      return Promise.reject(error)
    }
  )
}
